import type { CustomerStateType } from '@subscriptions/domain/types';
import { CustomerStates } from '@subscriptions/domain/types';

/**
 * Validated subscription block customer state value object.
 * The empty string represents an absent/unknown state produced by soft-validation reconstruction.
 */
export type CustomerState = Readonly<CustomerStateType | ''>;

const validStates = Object.values(CustomerStates) as string[];

/**
 * Creates a validated CustomerState value object.
 *
 * @param raw - Raw customer state string
 * @returns Validated CustomerState
 * @throws Error if state is not a valid value
 */
export const createCustomerState = (raw: string): CustomerState => {
  if (!validStates.includes(raw)) {
    throw new Error(`Invalid customer state: ${raw}. Must be one of: ${validStates.join(', ')}`);
  }
  return raw as CustomerState;
};
